import styles from "./styles.module.scss";
import img1 from "./img/1.png";
import img2 from "./img/2.png";
import img3 from "./img/3.png";
import img4 from "./img/4.png";

import { IconCardWalky } from "src/routes/onboarding/shared/components/iconCardWalky";
import { WALKY_KEYS } from "src/routes/onboarding/shared/constants/walkyKeys";

const data = [
  {
    value: "I only drink coffee or tea",
    displayValue: "I only drink coffee or tea",
    emoji: img1,
  },
  {
    value: "About 2 glasses (16 oz)",
    displayValue: "About 2 glasses (16 oz)",
    emoji: img2,
  },
  {
    value: "2 to 6 glasses (16-48 oz)",
    displayValue: "2 to 6 glasses (16-48 oz)",
    emoji: img3,
  },
  {
    value: "More than 6 glasses",
    displayValue: "More than 6 glasses",
    emoji: img4,
  },
];
export const WaterIntake = ({ onNextStep, onTrackEvent }) => {
  const handleNextStep = (v) => {
    localStorage.setItem(WALKY_KEYS.energyLevels, v.points);
    onNextStep(v.value);
    onTrackEvent?.(v.displayValue);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2>What is your daily water intake?</h2>
        <div className={styles.cards}>
          {data.map((value) => (
            <IconCardWalky
              onClick={() => handleNextStep(value)}
              img={value.emoji}
              title={value.displayValue}
              key={value.points}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
